import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const getSchedulerConfig = () =>
  axiosInstance.get("/fee-scheduler/config").then((r) => r.data);
export const updateSchedulerConfig = (data) =>
  axiosInstance.put("/fee-scheduler/config", data).then((r) => r.data);
export const requestSchedulerApproval = () =>
  axiosInstance.post("/fee-scheduler/request-approval").then((r) => r.data);
export const approveSchedulerConfig = (data = {}) =>
  axiosInstance.post("/fee-scheduler/approve", data).then((r) => r.data);
export const pauseScheduler = (data) =>
  axiosInstance.post("/fee-scheduler/pause", data).then((r) => r.data);
export const listSchedulerRuns = (params = {}) =>
  axiosInstance.get("/fee-scheduler/runs", { params }).then((r) => r.data);
export const previewScheduler = () =>
  axiosInstance.get("/fee-scheduler/preview").then((r) => r.data);
export const runSchedulerNow = () =>
  axiosInstance.post("/fee-scheduler/run-now").then((r) => r.data);

export const getSchedulerConfigPortal = () =>
  axiosInstance.get("/fee-scheduler-portal/config").then((r) => r.data);
export const updateSchedulerConfigPortal = (data) =>
  axiosInstance.put("/fee-scheduler-portal/config", data).then((r) => r.data);
export const requestSchedulerApprovalPortal = () =>
  axiosInstance.post("/fee-scheduler-portal/request-approval").then((r) => r.data);
export const pauseSchedulerPortal = (data) =>
  axiosInstance.post("/fee-scheduler-portal/pause", data).then((r) => r.data);
export const listSchedulerRunsPortal = (params = {}) =>
  axiosInstance.get("/fee-scheduler-portal/runs", { params }).then((r) => r.data);
export const previewSchedulerPortal = () =>
  axiosInstance.get("/fee-scheduler-portal/preview").then((r) => r.data);

export const addSchedulerSchedule = (data) =>
  axiosInstance.post("/fee-scheduler/schedules", data).then((r) => r.data);
export const removeSchedulerSchedule = (scheduleId) =>
  axiosInstance.delete(`/fee-scheduler/schedules/${scheduleId}`).then((r) => r.data);
export const approveSchedulerSchedule = (scheduleId) =>
  axiosInstance.post(`/fee-scheduler/schedules/${scheduleId}/approve`).then((r) => r.data);
export const addSchedulerSchedulePortal = (data) =>
  axiosInstance.post("/fee-scheduler-portal/schedules", data).then((r) => r.data);
export const removeSchedulerSchedulePortal = (scheduleId) =>
  axiosInstance.delete(`/fee-scheduler-portal/schedules/${scheduleId}`).then((r) => r.data);
export const approveSchedulerSchedulePortal = (scheduleId) =>
  axiosInstance.post(`/fee-scheduler-portal/schedules/${scheduleId}/approve`).then((r) => r.data);